export class Concept {
    server_concept_id=0
    name :string
    title:string
    description:string
    
}
